import { render, staticRenderFns } from "./xsqytj.vue?vue&type=template&id=6f96d2a9&"
import script from "./xsqytj.vue?vue&type=script&lang=js&"
export * from "./xsqytj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports